import React, { memo } from 'react';
import { View, Image } from 'react-native';
import { IconEdit, FilePicker, IconPlus } from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export const ImageCircularUploaderItem = memo(
  ({ status, progress = 0, thumbnail, onChange, disabled, size = 75 }) => {
    const { styles, colors } = useStyle();
    const isEmpty = status === ImageCircularUploaderItem.status.none;
    const isBusy =
      status === ImageCircularUploaderItem.status.busy ||
      (progress > 0 && progress < 100) ||
      (progress > 0 && !thumbnail && !isEmpty);
    const isSelected = status === ImageCircularUploaderItem.status.selected;
    return (
      <View style={styles.container}>
        <View style={[styles.contentContainer, { width: size, height: size }]}>
          {isSelected && (
            <>
              {thumbnail && (
                <Image
                  source={{ uri: thumbnail }}
                  style={styles.thumbnailImage}
                />
              )}
            </>
          )}
        </View>
        {isBusy && <ProgressBar {...{ progress }} />}
        <FilePicker
          style={[styles.actionButton, styles.editButton]}
          {...{ disabled, onChange }}
        >
          {isEmpty ? (
            <IconPlus size={30} color={colors.white} />
          ) : (
            <IconEdit size={30} color={colors.white} />
          )}
        </FilePicker>
      </View>
    );
  }
);

const ProgressBar = memo(({ progress }) => {
  const { styles, colors } = useStyle();
  return (
    <View style={styles.progressIndicatorContainer}>
      <CircularProgressbar
        strokeWidth={5}
        value={progress}
        styles={buildStyles({
          rotation: 1,
          strokeLinecap: 'butt',
          pathColor: colors.green1,
          trailColor: colors.gray22,
        })}
      />
    </View>
  );
});

ImageCircularUploaderItem.status = {
  none: 1,
  busy: 2,
  selected: 3,
};

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    borderRadius: 100,
    overflow: 'hidden',
    backgroundColor: colors.gray7,
  },
  actionButton: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 13,
    width: 26,
    height: 26,
    padding: 3,
    bottom: 1,
    zIndex: 10,
    borderColor: colors.white,
    borderWidth: 2,
    position: 'absolute',
  },
  editButton: {
    left: 5,
    backgroundColor: colors.blue1,
  },
  deleteButton: {
    right: 5,
    backgroundColor: colors.red1,
  },
  progressIndicatorContainer: {
    width: 80,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
  },
  thumbnailImage: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
}));
